const Screen = () => {

	return (
		<>
            <div className="_container">
                <div className="_lily_pad_h_d" style={{marginTop: 100, marginBottom: 100}}>
                    <h1 className="_roboto">Off<span style={{color: '#bbb', textDecoration: 'underline'}}>line</span></h1>
                </div>
            </div>
		</>
	);
}

export default Screen;